/* CONSTANTS & VARIABLES --------------------------------------------------------------------------------------------------------------------------------------------------------- */

  const isProduct = window.location.pathname.includes("/products/");
  const isCart = window.location.pathname.includes("/cart");
  const isEFA = isProduct && product.tags && product.tags.includes("EFA");

  const userPreferences = JSON.parse(localStorage.getItem("sb-user-preferences")) || {
    deliveryMethod: null,
    store: {
      name: null,
      storePrefix: null,
      erBranchId: null
    },
    zipcode: null
  };

  if (!userPreferences.store) userPreferences.store = {
    name: null,
    storePrefix: null,
    erBranchId: null
  };

  if (!userPreferences.zipcode) userPreferences.zipcode = null;

  
/* LISTENERS --------------------------------------------------------------------------------------------------------------------------------------------------------------------- */

  // on page ready, remove loading class
  $(document).ready(() => {
    if (isProduct) { 
      autofillUserPreferences().then(() => {
        if (isRental) openFirstIncompleteStep();
      });
    }
    $(".delivery-method-tile.loading").removeClass("loading");
  });

  // listen for primary selection
  $(".delivery-method-tile--primary").on("click", e => handleDeliveryMethodTileSelection(e.target.closest(".delivery-method-tile")));

  // listen for store selection
  $('[name="secondary-selector--store"]').on("change", e => {
    
    //  console.log("store selected", e.target.value);

    // get necessary elements
    const group = e.target.closest(".delivery-method-tiles--wrapper");
    const tile = e.target.closest(".delivery-method-tile");

    // update tile data
    tile.setAttribute("data-value", `Pick up at ${e.target.value}`);
    if (tile.dataset.value) tile.querySelector(".delivery-method-tile--title").innerHTML = `<div>Pick up at <a>${e.target.value}</a></div>`;
    setDeliveryMethodValue(group, tile.dataset.value);

    // update user preferences
    userPreferences.store.name = e.target.value;
    userPreferences.store.storePrefix = e.target.dataset.storePrefix;
    userPreferences.store.erBranchId = e.target.dataset.erBranchId;
    localStorage.setItem("sb-user-preferences", JSON.stringify(userPreferences));
    
    if (isRental) {
      const step = group.closest('.rental-step');
      stepComplete(step)? updateStepStatus(step, true) : updateStepStatus(step, false);
    };
  })

  // listen for doordash zipcode input
  $("[name='doordash-zip-code']").on("input", e => {
    console.log("doordash zipcode input", e.target.value);
    const group = e.target.closest(".delivery-method-tiles--wrapper");
    handleDoorDashZipcodeInput(e.target).then(() => setDeliveryMethodValue(group));
  })

  // listen for delivery method change request
  $(".delivery-method-change-request-link").on("click", e => {
    e.preventDefault();
    e.target.closest(".delivery-method-tiles--wrapper").classList.toggle("changing");
  });
  

/* FUNCTIONS --------------------------------------------------------------------------------------------------------------------------------------------------------------------- */

  async function autofillUserPreferences() {
    if (!isProduct || !userPreferences || isEFA) return;
    const cart = await getCart();
    const autofillGroup = document.querySelector(".delivery-method-tiles--wrapper");
    const autofillMethod = cart.attributes["Rental Delivery Method"] && cart.attributes["Rental Delivery Method"].includes("Pick up") ? "pickup" 
      : cart.attributes["Rental Delivery Method"] && cart.attributes["Rental Delivery Method"].includes("Ship") ? "ship"
      : cart.attributes["Rental Delivery Method"] && cart.attributes["Rental Delivery Method"].includes("DoorDash") ? "doordash"
      : userPreferences.deliveryMethod === 'pickup' && userPreferences.store ? `Pick up at ${userPreferences.store.name}`
      : userPreferences.deliveryMethod === 'doordash' ? `DoorDash to ${userPreferences.zipcode}`
      : userPreferences.deliveryMethod === 'ship' ? `Ship to you`
      : null;
    setDeliveryMethodValue(autofillGroup, autofillMethod).then(() => {;
      if (isRental) {
      } else {
        updateAddToCartButton(getSelectedVariant());
      }
    });

     // prefill prefered store
    if (userPreferences.store && userPreferences.store.name) {
      autofillGroup.querySelector(`[name="secondary-selector--store"][value="${userPreferences.store.name}"]`).setAttribute("checked", "true");
      autofillGroup.querySelector('.delivery-method-tile[data-method="pickup"]').setAttribute("data-value", `Pick up at ${userPreferences.store.name}`);
      autofillGroup.querySelector('.delivery-method-tile[data-method="pickup"] .delivery-method-tile--title').innerHTML = `<div>Pick up at <a>${userPreferences.store.name}</a></div>`;
    }

  }

  async function getSameDayAvailability(articleNumber, zipcode) {
    if (!articleNumber || !zipcode) return false;
    const samedayStores = getDoorDashStores(zipcode);
    const storesWithInventory = await getAvailableStores(articleNumber); // get stores with inventory for this article
    // console.log("storesWithInventory", storesWithInventory);
    // console.log("samedayStores", samedayStores);
    const samedayStoresWithInventory = samedayStores.filter(store => storesWithInventory.includes(store.name) || storesWithInventory.includes(store.short_name));
    // console.log("samedayStoresWithInventory", samedayStoresWithInventory, samedayStoresWithInventory.length > 0);
    if (samedayStoresWithInventory.length > 0) return true;
    return false;
  }

  function getSameDayAvailabilityRentals(zipcode) {

    if (!zipcode) return false;

    // get stores within DoorDash range of this zipcode
    const doordashStores = getDoorDashStores(zipcode);
    if (!doordashStores || doordashStores.length === 0) return false;

    // get stores tagged for no pickup
    const noPickupStores = product.tags
      .filter(tag => tag.startsWith("NOPICKUP-"))
      .map(tag => tag.replace("NOPICKUP-", ""));

    // remove any no-pickup stores from available DoorDash stores
    doordashStores.forEach(store => {
      if (noPickupStores.includes(store.store_prefix)) {
        const index = doordashStores.indexOf(store);
        if (index !== -1) doordashStores.splice(index, 1);
      }
    });

    if (!doordashStores || doordashStores.length === 0) return false;
    return doordashStores;
  }


  function getDoorDashStores(zipcode) {
    // pointing retail products at rental zip codes as of 2024-10-31 per Anthony
    if (!zipcode) return false;
    const doorDashStores = [...stores];
    // console.log("doorDashStores", doorDashStores);
    // filter door dash stores by zipcode in doordash_zipcodes_rental
    const availableDoorDashStores = doorDashStores.filter(store => store.doordash_zipcodes_rental.includes(Number(zipcode)));
    // console.log("availableDoorDashStores", zipcode, availableDoorDashStores);
    return availableDoorDashStores;
  }

  function getSelectedVariant() {
    const selectedVariantId = document.querySelector('[name="id"]').value
    return product.variants.find(variant => variant.id === Number(selectedVariantId));
  }

  async function handleDeliveryMethodTileSelection(tile) {

    if (!tile) return; // abort if no tile is found
    if (tile.classList.contains("loading")) return; // abort if still loading

    document.querySelectorAll(".delivery-method-tile--secondary").forEach(t => t.classList.remove("open")); // close all secondary selection drawers

    const group = tile.closest(".delivery-method-tiles--wrapper"); // get tile group
    const tileSelected = tile.classList.contains("selected"); // check if tile is selected
    const deliveryMethod = tile.dataset.value || null; // get tile delivery method value
    const secondarySelectionDrawer = tile.querySelector(".delivery-method-tile--secondary") || null; // get secondary selection drawer

    if (tileSelected && secondarySelectionDrawer) secondarySelectionDrawer.classList.toggle("open");
    if (!tileSelected) { 
      group.querySelectorAll(".delivery-method-tile").forEach(t => t.classList.remove("selected")); // clear any previous selection
      if (deliveryMethod) {
        tile.classList.add("selected"); // mark tile as selected
      } else if (!tileSelected && !deliveryMethod && secondarySelectionDrawer) {
        secondarySelectionDrawer.classList.toggle("open"); // toggle secondary selection drawer
      }
      setDeliveryMethodValue(group, deliveryMethod); // set delivery method
    }

    // check store availability, if necessary
    if (secondarySelectionDrawer && secondarySelectionDrawer.classList.contains("open") && tile.dataset.method === "pickup") updateStoresAvailability();

    // update user preferences
    userPreferences.deliveryMethod = tile.dataset.method;
    localStorage.setItem("sb-user-preferences", JSON.stringify(userPreferences));

  }

  async function handleDoorDashZipcodeInput(input) {
    if (!input) return;
    input.value = input.value.replace(/[^0-9]/g, ''); // disallow non-numbers
    input.value = input.value.slice(0, 5); // limit to 5 characters
    const group = input.closest(".delivery-method-tiles--wrapper"); // get tile group
    validateDoorDashZipcodeInput(input.value, group).then(valid => {
      setDeliveryMethodValue(group, valid ? `DoorDash to ${input.value}` : null); // set delivery method value
      return valid;
    }).catch(error => { 
      console.error("Error validating DoorDash zipcode:", error);
      return false;
    });
  }

  async function validateDoorDashZipcodeInput(zipcode, group) {
    if (!zipcode) return;

    try {
      const tile = group.querySelector(`.delivery-method-tile[data-method="doordash"]`); // get parent tile
      const tileTitle = tile.querySelector(".delivery-method-tile--title"); // get tile title
      const zipCodeStatus = group.querySelector(".zip-code-status"); // get zip code status element
      const zipcodeInput = group.querySelector('[name="doordash-zip-code"]'); // get zip code input element
      
      // if valid zip code
      if (zipcode.length === 5) {
  
        const selectedArticle = isProduct ? $("#article-number > span").text().replace("Article #", "").trim()
          : isCart ? group.dataset.article
          : undefined; // get article number
        zipCodeStatus.innerHTML = "Checking availability..."; // loading status
  
        // check article availability for this zip code
        const isAvailable = isCart && group.classList.contains("rental") ? await getSameDayAvailabilityRentals(zipcode) 
          : isCart && !group.classList.contains("rental") ? await getSameDayAvailability(selectedArticle, zipcode)
          : isRental ?await getSameDayAvailabilityRentals(zipcode) 
          : await getSameDayAvailability(selectedArticle, zipcode);

        const zipcodeColor = isAvailable ? "text-sb-green" : "text-sb-red";
        const zipcodeStatusIcon = isAvailable ? "sb-icon-success" : "sb-icon-cancel";
        const zipcodeStatusText = isAvailable ? "Order by 3pm for delivery today" : "Oh no! The selected product is currently unavailable for delivery in this ZIP code.";
        tile.dataset.value = isAvailable ? `DoorDash to ${zipcode}` : ""; 
        zipCodeStatus.innerHTML = `<span class="${zipcodeColor} flex gap-2 items-center"><i class="${zipcodeStatusIcon}"></i><span>${zipcodeStatusText}</span></span>`;
        tileTitle.innerHTML = `DoorDash to <span class="${zipcodeColor}">${zipcode}</span>`;
        // update user preferences
        userPreferences.zipcode = zipcode;
        localStorage.setItem('sb-user-preferences', JSON.stringify(userPreferences));
        return isAvailable;

      
      } else if (zipcode.length > 5) { // if zipcode is too long
        zipcodeInput.value = zipcode.slice(0, 5); // limit to 5 characters
      
      } else { // if zipcode is too short
        zipCodeStatus.innerHTML = "Enter your delivery zip code";
        tileTitle.innerHTML = "DoorDash to you";
        tile.dataset.value = "";

      }
  
    } catch (error) {
      console.error(error);
    }

    return false;

  }

  async function setDeliveryMethodValue(group, deliveryMethod) {
    // console.log("setDeliveryMethodValue", deliveryMethod);
    if (!group) return `Delivery method not set. No delivery method group set.`;

    const deliveryMethodPropertyInput = group.querySelector(`input[name="properties[Delivery Method]"]`);
    const deliveryMethodAttributeInput = group.querySelector(`input[name="attributes[Rental Delivery Method]"]`);

    group.querySelectorAll(".delivery-method-tile").forEach(t => t.classList.remove("selected")); // clear any previous selection

    // handle no delivery method
    if (!deliveryMethod) {
      if (deliveryMethodPropertyInput) deliveryMethodPropertyInput.value = "";
      if (deliveryMethodAttributeInput) deliveryMethodAttributeInput.value = "";
      return;
    }

    // get delivery method type
    const deliveryMethodType = deliveryMethod.includes("Pick up") ? "pickup"
      : deliveryMethod.includes("DoorDash") ? "doordash"
      : deliveryMethod.includes("Ship") ? "ship"
      : null;

    // handle delivery method type error
    if (!deliveryMethodType) {
      console.error("No delivery method type");
      return;
    }

    // mark appropriate tile as selected
    const selectedMethodTile = group.querySelector(`.delivery-method-tile[data-method="${deliveryMethodType}"]`);
    if (!selectedMethodTile) return `Delivery method not set. No delivery method tile found.`;
    selectedMethodTile.classList.add("selected"); // mark tile as selected

    // handle delivery method type specific actions
    if (deliveryMethodType === "ship") { // mark ship tile as selected
      deliveryMethodPropertyInput.value = deliveryMethod;
      if (deliveryMethodAttributeInput) deliveryMethodAttributeInput.value = deliveryMethod;
    } else if (deliveryMethodType === "pickup") { // mark appropriate store as selected, if applicable
      const storeName = deliveryMethod.replace("Pick up at ", "");
      const storeSelector = group.querySelector(`[name="secondary-selector--store"][value="${storeName}"]`);
      if (storeSelector) storeSelector.setAttribute("checked", "true");
      deliveryMethodPropertyInput.value = deliveryMethod;
      if (deliveryMethodAttributeInput) deliveryMethodAttributeInput.value = deliveryMethod;
    } else if (deliveryMethodType === "doordash") { // set DoorDash zipcode, if applicable
      const zipcode = deliveryMethod.replace("DoorDash to ", "");
      const zipCodeInput = group.querySelector('[name="doordash-zip-code"]');
      if (zipCodeInput) zipCodeInput.value = zipcode;
      validateDoorDashZipcodeInput(zipcode, group).then(valid => {
        if (valid) {
          deliveryMethodPropertyInput.value = deliveryMethod;
          if (deliveryMethodAttributeInput) deliveryMethodAttributeInput.value = deliveryMethod;
        } else {
          deliveryMethodPropertyInput.value = "";
          if (deliveryMethodAttributeInput) deliveryMethodAttributeInput.value = "";
        }
      });
    }

    // handle rental products
    if (isRental) updateDatePicker();
    return `Delivery method set to ${deliveryMethod}`;

  }

  // update store availability in delivery method tiles        
  function updateStoresAvailability(articleNumber, tileGroup) {
    // console.log("updateStoresAvailability", articleNumber, tileGroup);
    articleNumber = articleNumber ? articleNumber : $('#article-number > span').text().replace("Article #", "").trim();
    if (!articleNumber) return;
    getAvailableStores(articleNumber).then((availableStores) => {

      // console.log("updateStoresAvailability availableStores", availableStores);

      // update store status elements
      const store_status_elements = tileGroup ? tileGroup.querySelectorAll('.delivery-method-tile--store') : document.querySelectorAll('.delivery-method-tile--store');
      store_status_elements.forEach((e) => {
        const store_name = e.getAttribute('data-store');
        availableStores.includes(store_name) ? e.setAttribute('data-store-instock', "true") : e.setAttribute('data-store-instock', "false");
      });

      // update store selector buttons
      const store_selectors = tileGroup ? tileGroup.querySelectorAll('[data-store-name]') : document.querySelectorAll('[data-store-name]');
      store_selectors.forEach(selector => {
        const store_name = selector.getAttribute('data-store-name');
        const storeInstock = availableStores.includes(store_name); 
        selector.setAttribute('data-store-instock', storeInstock);
        const selector_parent = selector.closest(".store-pickup-tile");
        if (selector_parent) selector_parent.setAttribute('data-store-instock', storeInstock);


        if (selector.checked) selector.closest(".delivery-method-tile").setAttribute('data-store-instock', storeInstock);
      });

    });
  }  
  